import styled from "styled-components";
import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const TitleEl = styled.h2`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2px;
  color: ${theme.colors.gray800};
  border: 1px solid ${theme.colors.gray600};
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: flex;
  gap: 10px;
`;
